import { eventsController } from '../../js/classes/eventsConroller';
import { removeHtmlScroll, closeAllModals, openModal } from '../../js/shared/utils';

if (typeof window.openModal === 'undefined') {
    window.openModal = openModal;
}

document.addEventListener('click', e => {
    const openModalTrigger = e.target.closest('.js-modal');
    if (openModalTrigger) {
        const targetID = openModalTrigger.getAttribute('data-modal-target');
        if (targetID) {
            openModal(targetID);
        }
    } else {
        const closeModalTrigger = e.target.closest('.js-modal-close');
        if (closeModalTrigger) {
            let eventData = {};
            const modalParent = closeModalTrigger.closest('.modal');
            if (modalParent) {
                const modalID = modalParent.getAttribute('data-modal-target');
                if (modalID) {
                    eventData.modalID = modalID;
                }
            }

            document.dispatchEvent(
                new CustomEvent('aconti.modalclose', {
                    detail: eventData
                })
            );

            closeAllModals();
        }
    }
});